var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.009,
    height: 17.009,
    viewBox: "0 0 17.009 17.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-info",
    "data-name": "Icon metro-info",
    d: "M10.012,6.978a.8.8,0,0,1,.8-.8h.532a.8.8,0,0,1,.8.8v.532a.8.8,0,0,1-.8.8H10.81a.8.8,0,0,1-.8-.8ZM13.2,14.685H8.949V13.622h1.063V10.433H8.949V9.37h3.189v4.252H13.2ZM11.075,1.928a8.5,8.5,0,1,0,8.5,8.5,8.5,8.5,0,0,0-8.5-8.5Zm0,15.415a6.91,6.91,0,1,1,6.91-6.91A6.91,6.91,0,0,1,11.075,17.343Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#de6438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon-info.d452743d0bda61416da45d9813c01a4b.svg";
export { ForwardRef as ReactComponent };